import { get } from 'lodash';

const root = state => get(state, 'ReportsState.reportsCommonReducer');
export const getTransactionTypesData = state =>
  get(root(state), 'transactionTypesData', []);
export const getLoadingTransactionTypesData = state =>
  get(root(state), 'loadingTransactionTypesData', false);
export const getLoadingTransactionTypesDataError = state =>
  get(root(state), 'loadingTransactionTypesDataError', null);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintError = state => get(root(state), 'printError', null);
export const getEmptyPrintResponse = state =>
  get(root(state), 'emptyPrintResponse', null);
export const getPrintData = state => get(root(state), 'printData', null);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/commonState/selectors.js